// @ts-check
import ProviderInfoCard from './ProviderInfoCard';

export default ProviderInfoCard;
